export default __webpack_public_path__ + "static/media/05.d111c155.jpg";